import "./Pagination.css";

// Возвращает список страниц для показа, например [1, 2, 3, 4, 5, "...", 28]
function getPages(current, total) {
  if (total <= 9) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  let start = Math.max(2, current - 2);
  let end = Math.min(total - 1, current + 2);

  // держим одинаковое количество кнопок у краёв
  if (current <= 4) {
    start = 2;
    end = 6;
  } else if (current >= total - 3) {
    start = total - 5;
    end = total - 1;
  }

  const pages = [1];
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i++) pages.push(i);
  if (end < total - 1) pages.push("...");
  pages.push(total);

  return pages;
}

export default function Pagination({ totalCount, pageSize = 30, offset, setOffset }) {
  const totalPages = Math.ceil(totalCount / pageSize);
  if (totalPages <= 1) return null;

  const currentPage = Math.floor(offset / pageSize) + 1;

  const goTo = (page) => {
    if (page < 1 || page > totalPages || page === currentPage) return;
    setOffset((page - 1) * pageSize);
  };

  const isFirst = currentPage === 1;
  const isLast = currentPage === totalPages;

  return (
    <div className="pagination">
      <button disabled={isFirst} onClick={() => goTo(1)} title="Առաջին էջ">
        «
      </button>
      <button disabled={isFirst} onClick={() => goTo(currentPage - 1)} title="Նախորդ">
        ‹
      </button>

      {getPages(currentPage, totalPages).map((page, i) =>
        page === "..." ? (
          <span key={`dots-${i}`} className="pagination-dots">
            …
          </span>
        ) : (
          <button
            key={page}
            className={page === currentPage ? "active" : ""}
            onClick={() => goTo(page)}
          >
            {page}
          </button>
        )
      )}

      <button disabled={isLast} onClick={() => goTo(currentPage + 1)} title="Հաջորդ">
        ›
      </button>
      <button disabled={isLast} onClick={() => goTo(totalPages)} title="Վերջին էջ">
        »
      </button>
    </div>
  );
}
